<template>
  <div
    v-if="moduleData"
    class="module-options"
  >
    <MediaOptions
      :canvas-name="canvasName"
      :is-audio-asset="isAudioAsset"
      :is-image-asset="isImageAsset"
      :is-video-asset="isVideoAsset"
      :use-channel-card-layout="useChannelCardLayout"
      :module-data="moduleData"
      @update-module="updateMediaOptions"
    />
    <ShapeBorderOptions
      :canvas-name="canvasName"
      :module-data="moduleData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import * as types from '@/lib/constants/store';
import MediaOptions from '@/components/media/MediaOptions.vue';
import ShapeBorderOptions from '@/components/modules/ShapeBorderOptions.vue';
import {
  useAssetStore,
  useEditorStore,
} from '@/stores';

export default {
  name: 'AssetModuleOptions',
  components: {
    MediaOptions,
    ShapeBorderOptions,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useAssetStore, [
      'assets',
    ]),
    asset() {
      if (!this.moduleData.options.asset_id) return null;
      return this.assets[this.moduleData.options.asset_id];
    },
    isAudioAsset() {
      return this.asset && this.asset.group === 'audio';
    },
    isImageAsset() {
      return this.asset && this.asset.group === 'image';
    },
    isVideoAsset() {
      return this.asset && this.asset.group === 'video';
    },
    useChannelCardLayout() {
      return this.asset?.type?.name === 'Channel' && this.moduleData.options.layout === 'top';
    },
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.UPDATE_MODULE,
    ]),
    updateMediaOptions(data) {
      this[types.UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
  },
};
</script>

<style lang="stylus">
.test-link-option {
  padding-top: $nebula-space-2x;
}
</style>
